import React, { useState, useEffect, useRef, Fragment } from "react";


//************** Hooks **************/
import { useForm } from "../../../../Hooks/useForm";

// Librerias de componentes
import { useFormik } from 'formik';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { toastShow } from '../../../../Services/ToastService';




import { getInfoMenu, getMenus, postMenu } from "../../../../API/Menu/MenuRequests";




export const ModalMenu = ({ menuDialog, setMenuDialog, hideDialog, IdMenu }) => {

    const [InputValues, setInputValues] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    const [formData, setFormData] = useState({});
    const [data, setData] = useState({});
    const toast = useRef(null)
    // const [menuDialog, setMenuDialog] = useState(false);


    const [menus, setMenus] = useState([])


    useEffect(() => {
        console.log(menuDialog);
        if (menuDialog) {
            getMenu()
        } else {
            setFormData({})
            formik.resetForm(formData)
        }
    }, [menuDialog])

    const getMenu = async () => {
        const tempo = await getMenus();
        setMenus(tempo);
        if (IdMenu > 0) {
            const tempoMenu = await getInfoMenu(IdMenu);
            setData(tempoMenu[0])
            formik.setValues({ ...tempoMenu[0] })
        }
    }

    const activoAPP = [
        {
            Id: true,
            Estado: "Activo"
        },
        {
            Id: false,
            Estado: "Inactivo"
        },

    ]

    const agregarMenu = async (data) => {
        data.URL = (data.URL === "" ? null : data.URL)
        data.IdContenedor = (data.IdContenedor ? data.IdContenedor: 0)
        const resultado = await postMenu(data);
        toastShow(toast, 'success', 'Creado', 'Informacion ingresada Correctamente.');
        setFormData({})
        formik.resetForm(formData)
        return true;

    }


    const inicioValores = {
        IdMenu: -1000,
        Menu: null,
        Icon: null,
        IconApp: null,
        URL: null,
        IdContenedor: 0,
        Orden: 0,
        MenuWeb: 1,
        ActivoAPP: 0
    }


    const formik = useFormik({
        initialValues: IdMenu > 0 ? data : inicioValores,
        validate: (data) => {
            let errors = {};

            if (!data.Menu) {
                errors.Menu = 'Se requiere el nombre del menu.';
            }

            if (!data.Icon) {
                errors.Icon = 'Se requiere el Icono del menu.';
            }
            return errors;
        },

        onSubmit: async (data) => {
            setFormData(data);
            await agregarMenu(data);

        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;

    };



    return (
        <Fragment>
            {/* <Button label={nombre} icon={icono} className={className} onClick={openNew} /> */}
            <div className="form-demo">

                <div className="flex justify-content-center" >
                    <Dialog visible={menuDialog} header="MENU" modal className="modal__contenedor modal__usuarios"
                        onHide={hideDialog}>
                        <Toast ref={toast} />
                        <form onSubmit={formik.handleSubmit} className="p-fluid" style={{ margin: "Auto", marginBottom: 0 }}>
                            <div className="modal__input-contenedor">
                                <div className="field col-6 me-2" >
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="Titulo" name="Titulo" value={formik.values.Titulo} onChange={formik.handleChange} autoFocus
                                            autoComplete="off" />
                                        <label htmlFor="Titulo" >Titulo</label>
                                    </span>
                                </div>
                                <div className="field col-6 me-2" >
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="Title" name="Title" value={formik.values.Title} onChange={formik.handleChange} autoFocus
                                            autoComplete="off" />
                                        <label htmlFor="Title" >Title</label>
                                    </span>
                                </div>
                            </div>
                            <div className="modal__input-contenedor">

                                <div className="field col-6 me-2" >
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="Menu" name="Menu" value={formik.values.Menu} onChange={formik.handleChange} autoFocus
                                            autoComplete="off" />
                                        <label htmlFor="Menu" >Nombre Menu</label>
                                    </span>
                                </div>
                                <div className="field col-6 me-2">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-arrow-up-right" />
                                        <InputText id="URL" name="URL" value={formik.values.URL} onChange={formik.handleChange} autoComplete="off"
                                        />
                                        <label htmlFor="URL" >URL</label>
                                    </span>
                                </div>

                            </div>
                            <div className="modal__input-contenedor">
                                <div className="field col-6 me-2" >
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="Icon" name="Icon" value={formik.values.Icon} onChange={formik.handleChange} autoFocus
                                            autoComplete="off" />
                                        <label htmlFor="Icon" >Icon</label>
                                    </span>
                                </div>
                                <div className="field col-6 me-2">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="IconApp" name="IconApp" value={formik.values.IconApp} onChange={formik.handleChange} autoFocus
                                            autoComplete="off" />
                                        <label htmlFor="IconApp" >IconApp</label>
                                    </span>
                                </div>

                            </div>
                            <div className="modal__input-contenedor">
                                <div className="field col-6 me-2">
                                    <span className="p-float-label">
                                        <Dropdown id="IdContenedor" name="IdContenedor" value={formik.values.IdContenedor} onChange={formik.handleChange} options={menus}
                                            optionLabel="Menu" placeholder="Menu" optionValue="IdMenu" filter showClear  />
                                        <label htmlFor="IconApp" >Contenedor</label>
                                    </span>
                                </div>
                                <div className="field col-6 me-2">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-align-justify" />
                                        <InputText id="Orden" name="Orden" value={formik.values.Orden} onChange={formik.handleChange} autoComplete="off"
                                        />
                                        <label htmlFor="Orden">Orden</label>
                                    </span>
                                </div>
                            </div>
                            <div className="modal__input-contenedor">
                                <div className="field col-6 me-2">
                                    <span className="p-float-label p-input-icon-right">
                                        <label htmlFor="dropdown">Activo Web</label>
                                        <Dropdown id="MenuWeb" name="MenuWeb" value={formik.values.MenuWeb} onChange={formik.handleChange} options={activoAPP}
                                            optionLabel="Estado" optionValue="Id" />
                                        <label htmlFor="IconApp" >Activo Web</label>
                                    </span>
                                </div>
                                <div className="field col-6 me-2">
                                    <span className="p-float-label p-input-icon-right">
                                        <label htmlFor="dropdown">Activo APP</label>
                                        <Dropdown id="ActivoApp" name="ActivoApp" value={formik.values.ActivoApp} onChange={formik.handleChange} options={activoAPP}
                                            optionLabel="Estado" optionValue="Id" />
                                        <label htmlFor="IconApp" >Activo APP</label>
                                    </span>
                                </div>
                            </div>
                            <div className="p-dialog-footer">
                                <Button label="Cancel" type="button" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                                <Button type='submit' label="Save" icon="pi pi-check" className="p-button-text" />
                            </div>

                        </form>
                    </Dialog>
                </div>
            </div>

        </Fragment>
    )
}

export default ModalMenu;